export const GestaoEnvioModais = {
  buscaAvancada: 'buscaAvancada',
  indicadores: 'indicadores',
  visualizarGestaoEnvio: 'visualizarGestaoEnvio',
};
